import React, { useState, useEffect } from 'react';
import Divider from '../../../CommonComponents/UIComponents/Divider/Divider';
import Close from '../../../../static/assets/svg/mui-icons/Close.svg';
import ArrowBack from '../../../../static/assets/svg/mui-icons/ArrowBack.svg';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';

const ExchangeHeader = props => {
  const { title, subtitle, history } = props;
  const [orderId, setOrderId] = useState('');
  const [itemId, setItemId] = useState('');
  useEffect(() => {
    const orderId = sessionStorageHelper.getItem('exchangeOrderId');
    setOrderId(orderId);
    const returnProductDetails = sessionStorageHelper.getItem('returnProduct') || {};
    const itemId = returnProductDetails && returnProductDetails.returnProductId;
    setItemId(itemId);
  }, []);
  /* window.open(`/customer/my/order/return/${orderId}/${itemId}`, '_self') */
  return (
    <>
      <div className="margin-t16 margin-b16 margin-l24 display-flex justify-space-between align-items-center">
        <div className="display-flex align-items-center">
          <img
            alt="arrow-back"
            className="margin-r20 cursor-pointer"
            src={ArrowBack}
            onClick={() => {
              if (history && history.goBack) history.goBack();
            }}
          />
          <div>
            {title && <div className="fs20 fw500">{title}</div>}
            {subtitle && (
              <div className="fs14" style={{ color: 'rgba(60, 60, 60, 0.54)' }}>
                {subtitle}
              </div>
            )}
          </div>
        </div>
        <img
          alt="close-icon"
          className="margin-r24 cursor-pointer"
          src={Close}
          onClick={() => window.open(`/customer/my/order/return/${orderId}/${itemId}`, '_self')}
        />
      </div>
      <div className="margin-b16">
        <Divider />
      </div>
    </>
  );
};

export default ExchangeHeader;
